import React from "react";

import styles from "./PolicyPage.module.css";

export default function PrivacyPolicyPage() {
	return (
		<div className={styles["policy-container"]}>
			<main className={styles["policy-content"]}>
				<div>
					<p className={styles["policy-text-header"]}>
						APPLICATION PRIVACY POLICY
					</p>
					<p className={styles["policy-text-section-title"]}>
						1. We respect your privacy
					</p>
					<p className={styles["policy-text"]}>
						(a) World Series of Mahjong respects your right to
						privacy and is committed to safeguarding the privacy of
						our customers and software application users. We adhere
						to the National Privacy Principles established by the
						Privacy Act 1988 (Cth). This policy sets out how we
						collect and treat your personal information.
					</p>
					<p className={styles["policy-text"]}>
						(b) Personal information means information we hold which
						is identifiable as being about you.
					</p>
					<p className={styles["policy-text-section-title"]}>
						2. Collection of personal information
					</p>
					<p className={styles["policy-text"]}>
						(a) World Series of Mahjong will, from time to time,
						receive and store personal information you enter onto
						our software application World Series of Mahjong,
						provide to us directly or give to us in other forms.
					</p>
					<p className={styles["policy-text"]}>
						(b) You may provide basic information such as your name,
						phone number, address and email address to enable us to
						send information, provide updates and process your
						product or service order. We may collect additional
						information at other times, including but not limited
						to, when you provide feedback, when you provide
						information about your personal or business affairs,
						change your content or email preference, respond to
						surveys and/or promotions, provide financial or credit
						card information, or communicate with our customer
						support.
					</p>
					<p className={styles["policy-text"]}>
						(c) Additionally, we may also collect any other
						information you provide while interacting with us.
					</p>
					<p className={styles["policy-text-section-title"]}>
						3. How we collect your personal information
					</p>
					<p className={styles["policy-text"]}>
						World Series of Mahjong collects personal information
						from you in a variety of ways, including when you
						interact with us electronically or in person, when you
						access our software application and when we provide our
						services to you. We may receive personal information
						from third parties. If we do, we will protect it as set
						out in this Privacy Policy.
					</p>
					<p className={styles["policy-text-section-title"]}>
						4. Use of your personal information
					</p>
					<p className={styles["policy-text"]}>
						(a) World Series of Mahjong may use personal information
						collected from you to provide you with information,
						updates and our services. We may also make you aware of
						new and additional products, services and opportunities
						available to you. We may use your personal information
						to improve our products and services and better
						understand your needs.
					</p>
					<p className={styles["policy-text"]}>
						(b) The Application may make third party social media
						features available to its users. We cannot ensure the
						security of any information you choose to make public in
						a social media feature. Also, we cannot ensure that
						parties who have access to such publicly available
						information will respect your privacy.
					</p>
					<p className={styles["policy-text"]}>
						(c) World Series of Mahjong may contact you by a variety
						of measures including, but not limited to telephone,
						email, sms or mail.
					</p>
					<p className={styles["policy-text-section-title"]}>
						5. Disclosure of your personal information
					</p>
					<p className={styles["policy-text"]}>
						(a) We may disclose your personal information to any of
						our employees, officers, insurers, professional
						advisers, agents, suppliers or subcontractors insofar as
						reasonably necessary for the purposes set out in this
						Policy. Personal information is only supplied to a third
						party when it is required for the delivery of our
						services.
					</p>
					<p className={styles["policy-text"]}>
						(b) We may from time to time need to disclose personal
						information to comply with a legal requirement, such as
						a law, regulation, court order, subpoena, warrant, in
						the course of a legal proceeding or in response to a law
						enforcement agency request.
					</p>
					<p className={styles["policy-text"]}>
						(c) We may also use your personal information to protect
						the copyright, trademarks, legal rights, property or
						safety of World Series of Mahjong, its application,
						website and customers or third parties.
					</p>
					<p className={styles["policy-text"]}>
						(d) Information that we collect may from time to time be
						stored, processed in or transferred between parties
						located in countries outside of Australia.
					</p>
					<p className={styles["policy-text"]}>
						(e) If there is a change of control in our business or a
						sale or transfer of business assets, we reserve the
						right to transfer to the extent permissible at law our
						user databases, together with any personal information
						and non-personal information contained in those
						databases. This information may be disclosed to a
						potential purchaser under an agreement to maintain
						confidentiality. We would seek to only disclose
						information in good faith and where required by any of
						the above circumstances.
					</p>
					<p className={styles["policy-text"]}>
						(f) By providing us with personal information, you
						consent to the terms of this Privacy Policy and the
						types of disclosure covered by this Policy. Where we
						disclose your personal information to third parties, we
						will request that the third party follow this Policy
						regarding handling your personal information.
					</p>
					<p className={styles["policy-text"]}>
						(g) We retain your personal information only for as long
						as necessary to fulfil the purposes for which it was
						collected, or as required by law. We will securely
						delete or anonymise your data when it is no longer
						needed, in accordance with our data retention policy.
					</p>
					<p className={styles["policy-text-section-title"]}>
						6. Security of your personal information
					</p>
					<p className={styles["policy-text"]}>
						(a) World Series of Mahjong is committed to ensuring
						that the information you provide to us is secure. In
						order to prevent unauthorised access or disclosure, we
						have put in place suitable physical, electronic and
						managerial procedures to safeguard and secure
						information and protect it from misuse, interference,
						loss and unauthorised access, modification and
						disclosure.
					</p>
					<p className={styles["policy-text"]}>
						(b) While we implement industry-standard security
						measures to protect the transmission and exchange of
						information, the nature of electronic communications
						means that we cannot guarantee absolute security. We
						maintain robust safeguards against unauthorised access
						and disclosure, but like all electronic systems, there
						remains a possibility that personal information may be
						accessed or disclosed in ways not anticipated by this
						Privacy Policy.
					</p>
					<p className={styles["policy-text"]}>
						(c) We implement industry-standard security measures,
						including encryption, access controls, and regular
						security audits, to protect your personal information.
						In the event of a data breach, we will notify affected
						users and relevant authorities within 72 hours, as
						required by applicable laws.
					</p>
					<p className={styles["policy-text-section-title"]}>
						7. Changes to Privacy Policy
					</p>
					<p className={styles["policy-text"]}>
						Please be aware that we may change this Privacy Policy
						in the future. We may modify this Policy at any time, in
						our sole discretion and all modifications will be
						effective immediately upon our posting of the
						modifications on our website or notice board. Please
						check back from time to time to review our Privacy
						Policy.
					</p>
					<p className={styles["policy-text-section-title"]}>
						8. Software Application
					</p>
					<p className={styles["policy-text-subsection-title"]}>
						8.1. When you use our Application
					</p>
					<p className={styles["policy-i-indent-text"]}>
						When you come to our application we may collect certain
						information such as mobile unique device ID, the IP
						address of your mobile device, mobile operating system,
						the type of mobile internet browsers you use, and
						information about the way you use the Application. This
						information is used in an aggregated manner to analyse
						how people use our site, such that we can improve our
						service.
					</p>
					<p className={styles["policy-text-subsection-title"]}>
						8.2. Cookies
					</p>
					<p className={styles["policy-i-indent-text"]}>
						We may from time to time use cookies on our software
						application. Cookies are very small files which a
						website uses to identify you when you come back to the
						application and to store details about your use of the
						application. Cookies are not malicious programs that
						access or damage your computer, tablet or smartphone.
						Most devices automatically accept cookies but you can
						choose to reject cookies by changing your devise
						settings. However, this may prevent you from taking full
						advantage of our application.
					</p>
					<p className={styles["policy-text-subsection-title"]}>
						8.3. Automatic collection
					</p>
					<p className={styles["policy-i-indent-text"]}>
						The software Application may collect certain information
						automatically, including, but not limited to, the type
						of mobile device you use, your mobile devices unique
						device ID, the IP address of your mobile device, your
						mobile operating system, the type of mobile Internet
						browsers you use, and information about the way you use
						the Application.
					</p>
					<p className={styles["policy-text-subsection-title"]}>
						8.4. Third parties
					</p>
					<p className={styles["policy-i-indent-text"]}>
						Our software application may from time to time have
						links to other applications or websites not owned or
						controlled by us. These links are meant for your
						convenience only. Links to third party applications and
						websites do not constitute sponsorship or endorsement or
						approval of these third parties. Please be aware that
						World Series of Mahjong is not responsible for the
						privacy practises of other such applications or
						websites. We encourage our users to be aware, when they
						leave our application or website, to read the privacy
						statements of each and every application or website that
						collects personal identifiable information.
					</p>
				</div>
			</main>
		</div>
	);
}
